<template>
  <transition :name="fadeIn">
    <div class="v-close-dialog" v-if="show">
      <div class="dialog-mask"></div>
      <div class="dialog" v-show="show">
        <div class="dialog-content">
          <div class="dialog-close">
            <img src="@/assets/icon-close2.png" @click="close"/>
          </div>
          <div class="text-content">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false);
    }
  },
  computed: {
    fadeIn() {
      return "fadeIn";
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/scss/px2rem.scss";

.v-close-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -webkit-user-drag: none;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-transition-property: background-color;
  transition-property: background-color;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 300ms;
  transition-duration: 300ms;
}

.dialog {
  z-index: 1000;
  width: px2rem(580);
  background-color: #fff;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -webkit-user-drag: none;
  // opacity: 0;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  border-radius: px2rem(16);
}

.dialog-content {
  position: relative;
  color: #333333;
  font-size: px2rem(28);
  letter-spacing: 0;
  line-height: px2rem(48);
  
  .dialog-close {
    position: absolute;
    top: px2rem(-70);
    right: 0;
    img {
      width: px2rem(50);
    }
  }
  
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.3s;
}
.fadeIn-enter,
.fadeIn-leave-active {
  opacity: 0;
}
</style>
